import { all } from 'redux-saga/effects'

import campaign from './campaign/sagas'
import store from './store/sagas'
import voucher from './voucher/sagas'
import login from './login/sagas'
import dashboard from './dashboard/sagas'

export default function * rootSaga () {
  return yield all(
    [
      campaign,
      store,
      voucher,
      login,
      dashboard
    ]
  )
}
